// extracted by mini-css-extract-plugin
module.exports = {"detailLabel":"ArticleDetails_detailLabel__k7lYs","detailValue":"ArticleDetails_detailValue__SkaFN"};